import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { AceCodeEditorTitle, EditorsTitle } from "../../../../Constants/Constants";
import CssMode from "./CssMode";
import HtmlMode from "./HtmlMode";
import JavascriptMode from "./JavascriptMode";
import PhpMode from "./PhpMode";

const AceCodeEditorContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={AceCodeEditorTitle} parent={EditorsTitle} />
      <Container fluid>
        <Row>
          <JavascriptMode />
          <HtmlMode />
          <CssMode />
          <PhpMode />
        </Row>
      </Container>
    </>
  );
};
export default AceCodeEditorContainer;
